import { useEffect } from "react";
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from "@mui/material";
import { t } from "i18next";
import UserTypes from "../../../../helpers/constants/UserTypes";
import PasswordInput from "../../../../components/PasswordInput";

function AddUserForm({ formData, setFormData, errors, setErrors, isEdit }) {
  const { user, name, email, password, passwordConfirm, type } = formData;
  const userType = JSON.parse(localStorage.getItem("user")).type;

  const handleChange = (value, name) => {
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: null
    });
  };

  // change 'perms' when user type changes
  useEffect(() => {
    handleChange(UserTypes[type].defaultPermission, "perms");
  }, [type]);

  useEffect(() => {
    if (password !== "" && passwordConfirm !== "" && password !== passwordConfirm) {
      setErrors({
        ...errors,
        passwordConfirm: t("message.password_confirm")
      });
    }
  }, [passwordConfirm]);

  return (
    <>
      <Grid container spacing={2} rowSpacing={2}>
        <Grid item md={6} xs={12}>
          <TextField id="user" label={`${t("user.user_id")}*`} variant="outlined" fullWidth className="ltr-textfield"
                     value={user} disabled={isEdit} error={errors?.user} helperText={errors?.user}
                     onChange={(e) => handleChange(e.target.value, "user")}
          />
        </Grid>

        <Grid item md={6} xs={12}>
          <TextField id="email" label={`${t("user.email")}*`} variant="outlined" fullWidth className="ltr-textfield"
                     value={email} error={errors?.email} helperText={errors?.email}
                     onChange={(e) => handleChange(e.target.value, "email")}
          />
        </Grid>

        {!isEdit &&
          <>
            <Grid item md={6} xs={12}>
              <PasswordInput
                id="password"
                label={t("auth.password")}
                value={password}
                error={errors?.password}
                onChange={(e) => handleChange(e.target.value, "password")}
              />
            </Grid>

            <Grid item md={6} xs={12}>
              <PasswordInput
                id="password-confirm"
                label={t("auth.password_confirm")}
                value={passwordConfirm}
                error={errors?.passwordConfirm}
                onChange={(e) => handleChange(e.target.value, "passwordConfirm")}
              />
            </Grid>
          </>
        }

        <Grid item md={6} xs={12}>
          <TextField id="name" label={t("user.full_name")} variant="outlined" fullWidth
                     value={name} inputProps={{ maxLength: 32 }}
                     onChange={(e) => handleChange(e.target.value, "name")}
          />
        </Grid>

        <Grid item md={6} xs={12}>
          <FormControl fullWidth>
            <InputLabel id="type">{t("user.type")}</InputLabel>
            <Select
              id="type-select"
              label={t("user.type")}
              labelId="type"
              value={type}
              onChange={(e) => handleChange(e.target.value, "type")}
            >
              {UserTypes.map(({ name, type }, index) => {
                return (userType <= type) &&
                  <MenuItem value={type} key={index}>{name}</MenuItem>
              })}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

    </>
  );
}

export default AddUserForm;
